var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/tooltip');
require('bootstrap/js/dist/util');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');

// require('feather-icons');
const feather = require('feather-icons')

// require('jquery-sticky');
require('@fortawesome/fontawesome-free');
require('magnific-popup');

const jsonp = require('jsonp');
window.jsonp = jsonp;

import Mmenu from 'mmenu-js';

import Swiper from 'swiper/bundle';
import Cookies from 'js-cookie';

$(function() {

    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    //feather icons
    feather.replace()

    const mmenu = new Mmenu('#mob-menu', {
        'extensions': [
            "pagedim-black"
        ],
    }, {
        // configuration
        offCanvas: {
            page: {
                 selector: '#offcanvas'
            }
        },
        classNames: {
            selected: "active"
        }
    });

    const mmenuApi = mmenu.API;
    mmenuApi.bind('open:after', function(){
        $('.btn-menu').addClass('open').attr('href','#offcanvas');
    });
    mmenuApi.bind('close:after', function(){
        $('.btn-menu').removeClass('open').attr('href','#mob-menu');
    });

    // $('.btn-collapse').on('click', function() {
    //     $(this).find('.feather').toggleClass('d-none');
    // });

    if ($('#category-slideshow').length) {

        // init Swiper:
        const catSwiper = new Swiper('.swiper--categories', {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 8,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            observer: true,
            observeParents: true,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                480: {
                    slidesPerView: 2,
                    spaceBetween: 24
                },
                // when window width is >= 480px
                640: {
                    slidesPerView: 3,
                    spaceBetween: 16
                },
                // when window width is >= 640px
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24
                }
            },
        });
    }


    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    $('.selectpicker').selectpicker();
    $('.select-newscategory').on('change', function(e){
        e.stopPropagation();
        let category = $(this).val();
        let path = $(this).data('path');
        document.location.href = path + category;
    });
    // $('#login-modal').on('shown.bs.modal', function() {
    //     $('#email-login-modal').trigger('focus')
    // })

    $('#reviewModal').on('shown.bs.modal', function() {
        $('#textarea-focus').trigger('focus')
    })



    // $('.page-scroll').bind('click', function(event) {
    //     var $anchor = $(this);
    //     var elId = $anchor.attr('href').replace('/', '');

    //     $('html, body').stop().animate({
    //         scrollTop: $(elId).offset().top
    //     }, 750, 'easeInOutExpo');

    //     event.preventDefault();
    // });

    // $(window).scroll(function(event) {
    //     var scroll = $(window).scrollTop();
    //     // Do something
    //     if ($(this).scrollTop() > 50) {
    //         // alert('hello');
    //         $('.main-nav').addClass('shrink-nav');

    //     } else {
    //         $('.main-nav').removeClass('shrink-nav');
    //     }

    // });

    // $(".btn-mob-filter").click(function(){
    //   $("#mob-filter").toggleClass("active");
    // });

    // $('.scrollup').click(function() {
    //      $("html, body").animate({
    //          scrollTop: 0
    //      }, 600);
    //      return false;
    //  });

    $('.announcement').each(function() {
        var $announcement = $(this);
        var announcementKey = 'announcement' + $announcement.data('id');

        if (!window.sessionStorage.getItem(announcementKey)) {
            $announcement.removeClass('d-none');
            $announcement.addClass('d-flex');
        }

        $announcement.find('button,a').on('click', function() {
            $announcement.addClass('hide');
            window.sessionStorage.setItem(announcementKey, 1);
        })
    })

    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });

    // $('[data-toggle="tooltip"]').tooltip();

    // add custom hover toggle for nav links
    $('[data-toggle-hover]').on('hover',function() {
        var $this = $(this);
        var targetClass = $this.data('toggle-hover');
        var $target = $this.closest('.' + targetClass).find('.' + targetClass + '-menu');
        $target.addClass('show');
        $target.parent().off('mouseleave').on('mouseleave', function() {
            $target.removeClass('show');
        });
    });

    //dropdown inside dropdown
    $('.dropdown.dropdown-keep-open').on({
        'mouseleave': function() {
            this.closable = true;
        },
        'mouseenter': function() {
            this.closable = false;
        },
        'hide.bs.dropdown': function(e) {
            if ($(e.target).hasClass('dropdown-keep-open')) {
                return this.closable;
            }

            return true;
        },
    })

    $('.btn-cart').each(function() {
        var $this = $(this);
        var productId = $this.data('id');
        if (!productId) return;

        $this.on('click', function() {
            var event = new CustomEvent('product::updated', {
                detail: { product_id: productId },
            });
            document.dispatchEvent(event);
        })
    });

    // Search Filters Datepicker
    // Using font-awesome 5 icons
    // $.extend(true, $.fn.datetimepicker.defaults, {
    //     icons: {
    //         time: 'fa fa-clock',
    //         date: 'fa fa-calendar',
    //         up: 'fa fa-arrow-up',
    //         down: 'fa fa-arrow-down',
    //         previous: 'fa fa-chevron-left',
    //         next: 'fas fa-chevron-right',
    //         today: 'fa fa-calendar-check',
    //         clear: 'fa fa-calendar-times',
    //         close: 'fa fa-times-circle'
    //     }
    // });
    $('.datepicker-start').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        //debug:true,
    });
    $('.datepicker-end').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        useCurrent: false, //Important! See issue #1075
        //debug:true,
    });

    $('.datepicker-start').on("dp.change", function(e) {
        $('.datepicker-end').data('DateTimePicker').minDate(e.date);
    });
    $('.datepicker-end').on("dp.change", function(e) {
        $('.datepicker-start').data('DateTimePicker').maxDate(e.date);
    });

    $('.reset-filter').on('click', function(e) {
        e.preventDefault();
        $(this).closest('form').find('input[type=text]').val('');
    });

    // download statement loading state
    // $('.download-statement').on('click', function() {
    //     // $(this).addClass('disabled').text('loading')
    //     $(this).attr('disabled', true).addClass('disabled').html('<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> Downloading...');
    //     // $(this).addClass('disabled').html('<i class="material-icons md-18 ml-1 fa-spin">refresh</i> Downloading');

    //     setCookie('downloadStarted', 0, 100); //Expiration could be anything... As long as we reset the value
    //     setTimeout(checkDownloadCookie, 1000); //Initiate the loop to check the cookie.
    // });

    // var downloadTimeout;
    // var checkDownloadCookie = function() {
    //     if (getCookie("downloadStarted") == 1) {
    //         setCookie("downloadStarted", "false", 100); //Expiration could be anything... As long as we reset the value

    //         $('.download-statement').attr('disabled', false).removeClass('disabled').html('<i class="material-icons md-18 mr-2">picture_as_pdf</i> View Statement');

    //     } else {
    //         downloadTimeout = setTimeout(checkDownloadCookie, 1000); //Re-run this function in 1 second.
    //     }
    // };

});

// var setCookie = function(name, value, expiry) {
//     var exdate = new Date();
//     exdate.setTime(exdate.getTime() + expiry * 1000);
//     var c_value = escape(value) + ((expiry == null) ? "" : "; expires=" + exdate.toUTCString());
//     document.cookie = name + "=" + c_value + '; path=/';
// };

// var getCookie = function(name) {
//     var i, x, y, ARRcookies = document.cookie.split(";");
//     for (i = 0; i < ARRcookies.length; i++) {
//         x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
//         y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
//         x = x.replace(/^\s+|\s+$/g, "");
//         if (x == name) {
//             return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y; //;//unescape(decodeURI(y));
//         }
//     }
// };

// https://help.sharpspring.com/hc/en-us/articles/115002321292-Submitting-Directly-to-Native-Form-Endpoints
// window.postToSharpSpring = function postToSharpSpring(params){

//     var __ss_noform = window.__ss_noform || [];

//     var url = 'https://app-3QNP1F5B2A.marketingautomation.services/webforms/receivePostback/XXX/';
//     var endpoint = 'XXX';
//     var endpointurl = url + endpoint + '/jsonp/';

//     let ssTracking = $.cookie('__ss_tk');
//     params += '&trackingid__sb='+ssTracking;

//     window.jsonp(endpointurl+'?'+params, null, (err, data) => {
//         console.log(err, data)
//     });

//     return true;

// }

window.Cookies = Cookies;

window.trackingEvent = function trackingEvent(eventName, data) {

    let event = new CustomEvent(eventName, {
        detail: data,
    });
    window.dispatchEvent(event);
}

window.goBack = () => {
    window.history.go(-1);
}

window.dispatchEvent(new CustomEvent('init'));
